module.exports = __webpack_public_path__ + "e89aa153c61cce06d1bcd0ba5a5f7ea1.png";